import { all } from 'redux-saga/effects';
import appSagas from './app/saga';
import authSagas from './auth/saga';
import languageSwitcherSagas from './languageSwitcher/saga';
import systemInfosSaga from './systemInfos/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    languageSwitcherSagas(),
    appSagas(),
    systemInfosSaga()
  ]);
}
